import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { ChatSlice, createChatSlice } from './ChatSlice';
import { createProfileTabSlice, ProfileTabSlice } from './ProfileTabManagerSlice';
import { createPatientListSlice, PatientListSlice } from './PatientListSlice';
import { createNoteSlice, NotesSlice } from './NotesSlice';

export const useEngageStore = create<ChatSlice & ProfileTabSlice & PatientListSlice & NotesSlice>()(
    devtools(
        persist(
            (...a) => ({
                ...createChatSlice(...a),
                ...createProfileTabSlice(
                    // @ts-ignore
                    ...a
                ),
                ...createPatientListSlice(
                    // @ts-ignore
                    ...a
                ),
                ...createNoteSlice(...a)
            }),
            { name: 'engageStore' }
        )
    )
);
